var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreative(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F94F4F",
    fillRule: "evenodd",
    d: "M13 0c6.08 0 11.186 4.175 12.607 9.814h-1.964c-.094.516-.283.93-.567 1.243-.284.312-.696.468-1.236.468-.486 0-1.013-.13-1.58-.387a52.835 52.835 0 01-1.845-.886 14.576 14.576 0 00-2.198-.875C15.413 9.126 14.532 9 13.572 9c-1.729 0-3.09.733-4.083 2.2-.937 1.384-1.432 3.234-1.484 5.551L8 17.165h4.357c.094-.502.307-.91.638-1.222.33-.312.773-.468 1.327-.468.46 0 .966.126 1.52.377a65.15 65.15 0 011.864.886c.69.339 1.449.634 2.28.885A9.31 9.31 0 0022.69 18c1.004 0 1.879-.275 2.625-.825C23.577 22.305 18.72 26 13 26 5.82 26 0 20.18 0 13S5.82 0 13 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreative);
export default __webpack_public_path__ + "static/media/creative.af94119f448ec566344593a82f61c743.svg";
export { ForwardRef as ReactComponent };